// extracted by mini-css-extract-plugin
module.exports = {"voucherAssignment":"VoucherAssignment_voucherAssignment__34Nqm","sendEmailModal":"VoucherAssignment_sendEmailModal__3fGT7"};